import { Link } from "react-router-dom";
import { Clock, Banknote, Users, HeartHandshake } from "lucide-react";

const perks = [
  {
    icon: Clock,
    title: "Fleksible arbejdstider",
    description: "Du vælger selv hvornår og hvor meget du vil arbejde. Vi tilpasser os din hverdag.",
  },
  {
    icon: Banknote,
    title: "Ordentlig løn og vilkår",
    description: "Konkurrencedygtig løn, fuld gennemsigtighed og overenskomstmæssige vilkår.",
  },
  {
    icon: Users,
    title: "Fagligt fællesskab",
    description:
      "Bliv en del af et netværk af erfarne sygeplejersker og SOSU-assistenter i plejesektoren.",
  },
  {
    icon: HeartHandshake,
    title: "Personlig opbakning",
    description:
      "En fast kontaktperson der kender dig og altid er klar til at hjælpe – også mellem vagterne.",
  },
];

export default function ForVikarer() {
  return (
    <section id="vikarer" className="section py-10 sm:py-14 md:py-18 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="kicker">For vikarer</span>
          <h2 className="section-title mt-2">Ordentlige vilkår og fleksible vagter</h2>
          <p className="section-subtitle">
            Hos Plejesøstrene får du mere end vagter. Du får en samarbejdspartner
            der prioriterer din trivsel og faglige udvikling.
          </p>
        </div>

        <div className="mt-10 grid sm:grid-cols-2 gap-5">
          {perks.map((p) => (
            <div key={p.title} className="card p-5 flex gap-4">
              <div className="w-10 h-10 rounded-lg bg-brand-50 flex items-center justify-center shrink-0">
                <p.icon className="text-brand-600" size={20} />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900 text-sm">
                  {p.title}
                </h3>
                <p className="mt-1 text-sm text-slate-500 leading-relaxed">
                  {p.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <a href="#kontakt" className="btn btn-primary btn-lg">
            Ansøg som vikar
          </a>
          <Link to="/for-vikarer" className="btn btn-secondary btn-lg">
            Læs mere om at være vikar
          </Link>
        </div>
      </div>
    </section>
  );
}
